import * as React from "react";
import { SectionTitle } from "./SectionTitle.tsx";
import "./section.css";

interface Props {
  children?: React.ReactNode;
  title: string;
  titleRight?: React.ReactNode;
  /** A line under the title saying what it's for */
  description?: React.ReactNode;
}

/** A titled group of settings or details, on a paper panel. */
export const Section: React.FC<Props> = ({ children, title, titleRight, description }) => {
  return (
    <section className="section">
      <SectionTitle titleRight={titleRight}>{title}</SectionTitle>
      {description && <p className="section-description">{description}</p>}
      <div className="section-body">{children}</div>
    </section>
  );
};
